import { AsciiText } from '../framework/AsciiText';
import { ViscaBase } from './util/ViscaBase';
export class ViscaTcp extends ViscaBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
    }
    send(bytes) {
        this.socket.send(AsciiText.decode(bytes));
    }
}
ViscaTcp.emulatorType = 'socketEmulator';
ViscaTcp.key = '-LLzon5kEJ0cTR0z4DFm';
